export default "__VITE_ASSET__C8ft22aC__"